import ApiService from './api.service'

const BoosterImporterService = {
  async uploadFile(form) {
    try {
      const config = {
        'Content-Type': 'multipart/form-data'
      }

      return await ApiService.post('admin/booster-importer', form, config)
    } catch (error) {
      return error.response
    }
  },
  async getDocuments(page = 1) {
    try {
      return await ApiService.get(`booster-documents?page=${page}`)
    } catch (error) {
      return error
    }
  },
  async getDocument(id) {
    try {
      return await ApiService.get(`booster-documents/${id}`, {
        responseType: 'blob'
      })
    } catch (error) {
      return error
    }
  }
}

export { BoosterImporterService }
